import { core } from '../core/index.js';

export type FabricToolbarResetNavbarApi = () => void;

/**
 * 重置标题栏, 如果当前是float模式, 仍然保持, 只是重置调toolbar设置的按钮相关功能.
 */
export const resetNavbar: FabricToolbarResetNavbarApi = () => {
  core.call<'fabric_toolbar.resetNavbar'>('fabric_toolbar.resetNavbar');
};
